import classNames from 'classnames';
import React from 'react';

import { Icon } from '@sravni/react-design-system/lib/Icon';
import { Space } from '@sravni/react-design-system/lib/Space';
import { Text } from '@sravni/react-design-system/lib/Typography';
import { CoinsPlus } from '@sravni/react-icons';

import { Question } from '@src/components/icons';
import { CurrencySymbol } from 'shared/config/internalization';

import styles from './DefaultPromoInfoBox.module.scss';

interface Props {
  bonusAmount: number;
  onOpenSheet: () => void;
}

export const DefaultPromoInfoBox = ({ bonusAmount, onOpenSheet }: Props) => (
  <Space direction="row" justify="center" size={4} align="center" className={styles.alertContent}>
    <Icon className={classNames(styles.icon, 'h-color-static-light')} icon={<CoinsPlus />} />
    <Text size={14} className={classNames(styles.bonusTitle, 'h-color-static-light')}>
      Бонус от Сравни
    </Text>
    <Space direction="horizontal" className={styles.container}>
      <Text size={14} className="h-color-static-light">
        +{bonusAmount} {CurrencySymbol.RUB}
      </Text>
      <Icon className={styles.icon} onClick={onOpenSheet}>
        <Question />
      </Icon>
    </Space>
  </Space>
);
